import { render } from "./ManagedMaintenanceExplainedView.vue?vue&type=template&id=5caf061d&scoped=true"
import script from "./ManagedMaintenanceExplainedView.vue?vue&type=script&lang=js"
export * from "./ManagedMaintenanceExplainedView.vue?vue&type=script&lang=js"

import "./ManagedMaintenanceExplainedView.vue?vue&type=style&index=0&id=5caf061d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf061d"]])

export default __exports__